import * as Yup from 'yup'

export const nameSchema = Yup.object({
  name: Yup.string().min(3).max(200).required('Required')
})

export const emailSchema = Yup.object({
  email: Yup.string().email('Please enter a valid email').max(77).required('Required')
})
